"use client";

import { useFormStore } from "@/core/stores";
import { handleDeleteForm } from "@/features/form-functions";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { toast } from "sonner";

export function useDeleteForm() {
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { removeForm } = useFormStore();

  const deleteForm = async (formId: string) => {
    setLoading(true);
    try {
      const res = await handleDeleteForm(formId);
      if (res.error) return alert(res.error);
      router.push("/dashboard");
      removeForm(formId);
      toast("폼이 삭제되었어요.");
    } catch (e) {
      const error = e as Error;
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    deleteForm,
  };
}
